// extracted by mini-css-extract-plugin
export default {"tabContainer":"tab_tabContainer__E0lz8","tab":"tab_tab__nZQNe","active":"tab_active__uEnkj"};